'use client';

import React, { useState } from 'react';
import { SwiperOptions } from 'swiper';
import ReactImageCarousel, { Modal, ModalGateway } from 'react-images';
import clsx from 'clsx';
import placeholder from '../../../assets/icons/walker-profile/assets/walker-gallery-placeholder.png';
import photoIcon from '../../../assets/icons/walker-profile/assets/photo.svg';
import { Carousel } from '../../../components/Carousel';
import { WalkerGalleryResponse } from '../../../types/api';
import { pxToNumber } from '../../../wag-react/common/utils/pxToNumber';
import { LazyImage } from '../../../wag-react/components/lazyload/LazyImage';
import { theme } from '../../../wag-react/themes/base-theme';
import { Box } from '../../../wag-react/next-components/box';
const swiperParams = (slidesPerView = 3) => ({
  grabCursor: true,
  spaceBetween: 0,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 1,
    slideShadows: false
  },
  zoom: {
    maxRatio: 5
  },
  slidesPerView: 1,
  pagination: {
    type: 'fraction'
  },
  breakpoints: {
    [pxToNumber(theme.breakpoints[1])]: {
      slidesPerView,
      freeMode: false,
      pagination: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    }
  }
}) as Partial<SwiperOptions>;
type Props = {
  gallery: WalkerGalleryResponse;
  isMobile?: boolean;
};
export const ImageGallery = ({
  gallery,
  isMobile = false
}: Props) => {
  const images = gallery?.items?.length ? gallery.items.map(image => image?.url) : [];
  const singlePhotoView = isMobile || images.length < 7;
  const slides = singlePhotoView ? images.length : images.length / 5 + 2;
  const items = Array.from(Array(Math.round(slides)).keys());
  const [isModalOpen, setIsModalOpen] = useState(false);
  return items.length === 0 ? <Box px="0" height="320px" position="relative" className="px-[2%] h-[320px]" data-sentry-element="Box" data-sentry-component="ImageGallery" data-sentry-source-file="ImageGallery.tsx">
        <LazyImage height="100%" width="100%" src={placeholder} className="!p-0 h-full" style={{
      objectFit: 'cover'
    }} data-sentry-element="LazyImage" data-sentry-source-file="ImageGallery.tsx" />
      </Box> : <Box position="relative" zIndex={0} className="walker-profile-gallery" data-sentry-element="Box" data-sentry-component="ImageGallery" data-sentry-source-file="ImageGallery.tsx">
        {items.length > 3 && <Box display={['none', 'block']}>
            <Box zIndex={10} bg="rgba(0, 0, 0, .5)" color="white" py="5px" px="7px" bottom="20px" cursor="pointer" right="20px" onClick={() => setIsModalOpen(true)} position="absolute" borderRadius="6px" display="flex" alignItems="center">
              <LazyImage height="18px" width="18px" mr="4px" src={photoIcon} />
              View all photos
            </Box>
            {/* @ts-expect-error - Modal error */}
            <ModalGateway>
              {isModalOpen ? <Modal onClose={() => setIsModalOpen(false)}>
                  <ReactImageCarousel views={images.map(item => ({
            source: item
          }))} />
                </Modal> : null}
            </ModalGateway>
          </Box>}
        <Carousel swiperParams={swiperParams(slides > 3 ? 3 : slides)} px="0" py={isMobile ? 0 : 1} value={items} keyExtractor={(item: string) => item} bg={theme.colors.whiteSmoke} data-sentry-element="Carousel" data-sentry-source-file="ImageGallery.tsx">
          {(item: string) => Number(item) % 2 !== 0 || singlePhotoView ? <Box px={isMobile ? 0 : '1%'} height="320px" position="relative" className="px-[2%] h-[320px]">
                <LazyImage className={clsx('!p-0 h-full', !isMobile && '[&_img]:rounded-md')} width="100%" src={Number(item) % 2 !== 0 && !singlePhotoView ? images[Number(item) + 3] : images[Number(item)]} style={{
          objectFit: 'cover'
        }} />
              </Box> : <div className={clsx('flex flex-wrap justify-between w-full h-[320px] content-between')}>
                {Array.from(Array(4).keys()).map(key => <LazyImage key={key} className={clsx('!p-0 h-[49.5%]', !isMobile && '[&_img]:rounded-md')} borderRadius="5px" width="49.5%" src={images[Number(item) + key + (Number(item) > 0 ? 3 : 0)]} style={{
          objectFit: 'cover'
        }} />)}
              </div>}
        </Carousel>
      </Box>;
};